export class CompletionNumberLabelFilter {
    public IncludeInactive?: boolean;
}

export default CompletionNumberLabelFilter;